/*
 * @title App
 * @description Application entry point
 */

// Modules
import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'
import focus from '@alpinejs/focus'
import '../../node_modules/toastify-js/src/toastify.css';
import headerMegamenuExtended from '../modules/headers/header__megamenu-extended/header__megamenu-extended';
import headerMegamenuTabOrderMobile from '../modules/headers/header__megamenu-extended/tab-order-mobile';
import '../../node_modules/lazysizes/plugins/parent-fit/ls.parent-fit';
import login from './components/pageLogin';
import objectFitImages from './components/objectFitImages';
import blockMediaDownload from './components/block-media-download';
import headerIntranet from '../modules/intranet/header__intranet/header__intranet';
import footers from '../modules/footers/footers';
import watermark from '../modules/watermark/watermark';
import subscriptionModal from '../modules/modals/modal-subscription/modal-subscription';
import subscriptionMemberModal from '../modules/modals/modal-subscription/modal-member-subscription';
import pagination from '../modules/pagination/pagination';
import carouselCards from '../modules/carousels/carousel__cards/carousel__cards';
import articleAnchorMenu from '../modules/anchor-links/article-anchor-menu/article-anchor-menu';
import accordion from '../modules/accordions/accordion';
import autosuggestions from '../modules/search-bars/suggestions/autosuggestions.js';
import accordionMobile from '../modules/accordions/accordion--mobile/accordion--mobile';
import accordionDesktopDown from '../modules/accordions/accordion--desktop-down/accordion--desktop-down';
import infoboxLinksIcon from '../modules/info-boxes/info-box__links__icon/info-box__links__icon';
import threeColumnCarousel from '../modules/carousels/three-column-carousel/three-column-carousel';
import progress from '../modules/progressbar/progress';
import swiper from '../modules/carousels/swiper/swiper';
import heroMultiBox from '../modules/heros/hero__multi-box/hero__multi-box';
import video from '../modules/videos/video';
import videoDreambroker from '../modules/videos/video-dreambroker';
import videoYoutube from '../modules/videos/video-youtube';
import BorgerDk from '../modules/third-party/borgerDk/borgerDk';
import SBSYS from '../modules/third-party/sbsys/sbsysaccordion.js';
import smoothScroll from './components/smooth-scroll.js';
import pageLoader from './components/page-loader.js';
import cssVars from 'css-vars-ponyfill';
import tooltips from './components/tooltips';

import toastify from '../modules/modals/toastify/toastify';
import intextArrowLink from './components/intext-arrow-link';
import serviceMenu from '../modules/service-menu/service-menu';
import serviceMenuShareByEmail from '../modules/service-menu/service-menu__shareByEmail';
import dataTabel from '../modules/tabel/tabel';
import formElements from './components/form-elements';
import choicesJS from '../modules/form-elements/choices.js/choices.js';
import sideMenu from '../modules/side-menu/side-menu';
import instagramFeed from '../modules/third-party/instagram-feed/instagram-feed';
import counterAnimation from '../modules/side-boxes/side-boxes__counter/side-boxes__counter';
import kultunaut from '../modules/third-party/kultunaut/kultunaut-card/kultunaut-card';
import kultunautPopularEvent from '../modules/side-boxes/side-boxes__most-popular/side-boxes__most-popular';
import modalPopup from '../modules/modals/modal-popup/modal-popup';
import tabListScrollable from '../modules/intranet/tab-list--scrollable/tab-list--scrollable';
import videoBackground from './components/video-backgrounds';
import cludoSearch from '../modules/third-party/cludo-search/cludo-search';
import imageGallery from '../modules/image/image-gallery/image-gallery';
import chat from '../modules/intranet/chat/chat';
import onShowMore from '../modules/fact-box/onShowMore';
import collapseBox from '../modules/fact-box/collapseBox';
import onShowMoreCard from '../modules/cards/card__comment/onShowMoreCard';
import card__comment from '../modules/cards/card__comment/card__comment';
import header from '../modules/headers/header__transparent-menu/scripts/header';
import { moveNavItems } from '../modules/headers/header__transparent-menu/scripts/moveNavItems';
import parallax from '../modules/creative/parallax/parallax';
import dropdownMdDown from '../modules/dropdowns/dropdown--md-down/dropdown--md-down';
import bannerHours from '../modules/banners/banner__hours/bannerHours';
import videoHTML from '../modules/videos/video-html';
import breadcrumb  from '../modules/breadcrumbs/breadcrumb/breadcrumb';
import headerTagged from "../modules/headers/header--tagged/headerTagged";
import headerLeftAligned from '../modules/headers/header__megamenu-left-aligned/headerLeftAligned';
import doubleLogoMenu from '../modules/headers/header__double-logo/doubleLogoMenu';
import collapse from '@alpinejs/collapse';
import leftAlignedMegamenu from '../modules/headers/header__megamenu-left-aligned/leftAlignedMegamenu';
import unsaveButton from './components/unsaveButton';
import tableCSV from '../modules/tabel/table-csv/tableCsv.js';
import dropdownSettings from '../modules/dropdowns/dropdown-settings/dropdownSettings';
import tableHours from '../modules/table-hours/table-hours.js';
import tabpanel from '../modules/tab-panels/tab-panel.js';

import greyScaleInit from './components/init-grayscale';
import darkmodeScale from './components/dark-mode.js';
import headerMegamenuFocusTrap from '../modules/headers/header__megamenu-extended/focus-trap.js';
import print from './print.js';
import bannerAlert from '../modules/banners/banner__alert/bannerAlert.js';
import fixedAnchorMenu from '../modules/anchor-links/fixed-anchor-menu/fixed-anchor-menu.js';
import shareChatPost from '../modules/intranet/chat/shareChatPost.js';
import bookmark from './components/bookmarkButton.js';
import intranetProfileInfo from './components/intranetProfileInfo.js';
import jobnetList from './components/jobnet-list.js';

window.Alpine = Alpine;

Alpine.plugin(collapse);
Alpine.plugin(focus)
Alpine.plugin(intersect)
Alpine.data('collapseBox', collapseBox);
Alpine.data('card__comment', card__comment);
Alpine.data('headerTagged', headerTagged);
Alpine.data('headerLeftAligned', headerLeftAligned);
Alpine.start();

/* Safe init function */
function safeInit(fn, name) {
	var fnName = name || (fn && fn.name) || 'anonymous';

	try {
		if (typeof fn === 'function') {
		fn();
		}
	} catch (error) {
		console.error('[App init error] ' + fnName, error);
	}
}


document.addEventListener('DOMContentLoaded', function () {
	safeInit(headerMegamenuExtended);
	safeInit(headerMegamenuTabOrderMobile);
	safeInit(headerMegamenuFocusTrap);
	safeInit(leftAlignedMegamenu)
	safeInit(doubleLogoMenu);
	safeInit(login);
	safeInit(headerIntranet);
	safeInit(heroMultiBox);
	safeInit(footers);
	// watermark();
	safeInit(() => watermark('.footer'), 'watermark');
	safeInit(pageLoader);
	safeInit(smoothScroll);
	safeInit(blockMediaDownload);
	safeInit(objectFitImages);
	safeInit(subscriptionMemberModal);
	safeInit(subscriptionModal);
	safeInit(pagination);
	safeInit(carouselCards);
	safeInit(swiper);
	safeInit(articleAnchorMenu);
	safeInit(accordion);
	safeInit(accordionMobile);
	safeInit(accordionDesktopDown);
	safeInit(infoboxLinksIcon);
	safeInit(threeColumnCarousel);
	safeInit(progress);
	safeInit(video);
	safeInit(choicesJS);
	safeInit(toastify);
	safeInit(videoDreambroker);
	safeInit(videoYoutube);
	safeInit(videoHTML);
	safeInit(BorgerDk);
	safeInit(SBSYS);
	safeInit(tooltips);
	safeInit(intextArrowLink);
	safeInit(serviceMenu);
	safeInit(serviceMenuShareByEmail);
	safeInit(dataTabel);
	safeInit(formElements);
	safeInit(sideMenu);
	safeInit(instagramFeed);
	safeInit(counterAnimation);
	safeInit(modalPopup);
	safeInit(tabListScrollable);
	safeInit(videoBackground);
	safeInit(cludoSearch);
	safeInit(imageGallery);
	safeInit(chat);
	safeInit(onShowMore);
	safeInit(onShowMoreCard);
	safeInit(header);
	safeInit(kultunaut);
	safeInit(kultunautPopularEvent);
	safeInit(moveNavItems);
	safeInit(parallax);
	safeInit(dropdownMdDown);
	safeInit(bannerHours);
	safeInit(breadcrumb);
	safeInit(dropdownSettings);
	safeInit(unsaveButton);
	safeInit(tableCSV);
	safeInit(autosuggestions);
	safeInit(tableHours);
	safeInit(tabpanel);
	safeInit(bannerAlert);	
	safeInit(fixedAnchorMenu);
	safeInit(greyScaleInit);
	safeInit(darkmodeScale);
	safeInit(print);
	safeInit(shareChatPost);
	safeInit(bookmark);
	safeInit(intranetProfileInfo);
	safeInit(jobnetList);
	safeInit(() =>
		cssVars({
			rootElement: document,
		}),
		'cssVars'
	);
});
